module.exports = __webpack_public_path__ + "img/it.60341f1d.jpg";